module.exports = [
    {
      path: '/photo',
      component: true,
      redirect: '/photo/list',
      name: '图库管理',
      children: [
        {
          path: 'list',
          name: '列表',
          component: () => import('@/views/photo/list'),
        },
      ]
    },
  ]


// WEBPACK FOOTER //
// ./src/router/photo.js